import type { IApplicationContext } from 'shared/types/applicationContext';

import type { IDadataResponse, IDadataSuggestion } from './types';

const DADATA_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

interface IFetchAddressSuggestionsParams {
  query: string;
  count?: number;
}

export async function fetchAddressSuggestions(
  { config }: IApplicationContext,
  { query, count = 7 }: IFetchAddressSuggestionsParams,
): Promise<IDadataSuggestion[]> {
  if (!query.trim()) {
    return [];
  }

  const token = config.get<string>('Dailyrent.DaDataToken');

  const response = await fetch(DADATA_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({
      query,
      count,
      to_bound: { value: 'flat' },
    }),
  });

  if (!response.ok) {
    return [];
  }

  const data: IDadataResponse = await response.json();

  return data.suggestions;
}
